// === Track Your Order Frontend Script ===
document.addEventListener("DOMContentLoaded", () => {
  // === Select DOM Elements ===
  const trackBtn = document.getElementById("trackbtn");
  const orderInput = document.getElementById("TrackingNumber");
  const resultDiv = document.getElementById("trackingResult");
  const spinner = document.getElementById("spinner");
  const trackingInfoSection = document.getElementById("trackingInfo");
  const statusHeading = document.getElementById("trackingStatus");

  // === Base API URL ===
  const API_BASE = "https://track-order-six.vercel.app/api";

  // === Manual Tracking Button Click ===
  trackBtn?.addEventListener("click", () => {
    const trackingNumber = orderInput.value.trim().toUpperCase();
    if (!trackingNumber) {
    trackingInfoSection.innerHTML = "";
      
      resultDiv.innerHTML = `<p class="error-message">Please enter a tracking number.</p>`;
      
      return;
    }
    fetchAndDisplayTracking(trackingNumber);
  });

  // === Fetch Tracking Data from API and Display ===
  async function fetchAndDisplayTracking(trackingNumber) {
    resultDiv.innerHTML = "";
    trackingInfoSection.style.display = "none";
    spinner.style.display = "block";

    const isLeopard = trackingNumber.startsWith("LE");
    const endpoint = `${API_BASE}/${isLeopard ? "leopard" : "postex"}/track`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ trackingNumber })
      });

      const data = await response.json();
      spinner.style.display = "none";

      if (!response.ok || !data || Object.keys(data).length === 0) {
        resultDiv.innerHTML = `<h1 class="error-message">Could Not Find Order</h1>`;
        return;
      }

      displayTrackingData(data, isLeopard);
    } catch (error) {
      spinner.style.display = "none";
      resultDiv.innerHTML = `<h1 class="error-message">Something went wrong. Try again later.</h1>`;
      console.error(error);
    }
  }

  // === Parse and Render Tracking Details ===
  function displayTrackingData(data, isLeopard) {
    trackingInfoSection.style.display = "block";
    let trackingDetails = [], trackingNumber = "", orderId = "";
    if (isLeopard) {
      const packet = data?.packet_list?.[0];
      trackingDetails = packet?.["Tracking Detail"] || [];
      trackingNumber = packet?.track_number || "";
      orderId = packet?.booked_packet_order_id || "";
    } else {
      trackingDetails = data?.dist?.transactionStatusHistory || [];
      trackingNumber = data?.dist?.trackingNumber || "";
      orderId = data?.dist?.orderRefNumber || "";
    }

    if (!trackingDetails.length) {
      resultDiv.innerHTML = `<h1 class="error-message">Could Not Find Order</h1>`;
      trackingInfoSection.style.display = "none";
      return;
    }

    const statusList = trackingDetails.map(entry => ({
      status: entry.Status || entry.status || entry.transactionStatusMessage,
      date: formatDate(entry.Activity_Date || entry.updatedAt)
    }));

    statusHeading.textContent = `Order ${orderId}`;
    fetchShopifyOrderDetails(orderId);
    renderDynamicStatusBar(statusList);
    renderTrackingHistory(trackingDetails,trackingNumber);
  }

  // === Create and Display the Animated Status Bar ===
  function renderDynamicStatusBar(statusList) {
    const statusBar = document.getElementById("statusBar");
    statusBar.innerHTML = "";
    if (!statusList.length) return;

    const container = document.createElement("div");
    container.className = "animated-status-bar";

    // === Map status keywords to icons and labels ===
    const iconMap = [
      { keywords: ["ordered"], icon: "fa-shopping-cart", label: "Ordered" },
      { keywords: ["order ready", "order prepared"], icon: "fa-box-open", label: "Order Ready" },
      { keywords: ["picked"], icon: "fa-box", label: "Shipment Picked" },
      { keywords: ["dispatch", "departed"], icon: "fa-truck", label: "Dispatched" },
      { keywords: ["in transit"], icon: "fa-shipping-fast", label: "In Transit" },
      { keywords: ["arrived", "received"], icon: "fa-warehouse", label: "Arrived at Station" },
      { keywords: ["assigned", "enroute", "out for delivery"], icon: "fa-user-check", label: "Out for Delivery" },
      { keywords: ["pending", "waiting"], icon: "fa-clock", label: "Pending" },
      { keywords: ["attempt made", "refused"], icon: "fa-times-circle", label: "Attempt Failed" },
      { keywords: ["return"], icon: "fa-undo", label: "Return in Progress" },
      { keywords: ["delivered"], icon: "fa-check-circle", label: "Delivered" },
    ];

    // === Remove duplicate dates, keep latest status ===
    const uniqueDateMap = new Map();
    for (let i = statusList.length - 1; i >= 0; i--) {
      const date = statusList[i].date;
      if (!uniqueDateMap.has(date)) uniqueDateMap.set(date, statusList[i]);
    }
    const filteredStatusList = Array.from(uniqueDateMap.values()).reverse();

    filteredStatusList.forEach((item, i) => {
      const lower = item.status.toLowerCase();
      const matched = iconMap.find(m => m.keywords.some(k => lower.includes(k)));
      const iconClass = matched?.icon || "fa-circle";
      const label = matched?.label || item.status;

      const step = document.createElement("div");
      step.className = `status-step ${i < filteredStatusList.length - 1 ? "completed" : "active"}`;
      step.innerHTML = `
        <div class="step-icon"><i class="fas ${iconClass}"></i></div>
        <div class="step-info">
          <div class="step-status">${label}</div>
          <div class="step-date">${item.date}</div>
        </div>`;
      container.appendChild(step);
    });

    statusBar.appendChild(container);
  }

// === Render Tracking History Below the Status Bar ===
function renderTrackingHistory(history,trackingNumber) {
  console.log(trackingNumber)
  const historyContainer = document.createElement("div");
  historyContainer.className = "history-container";

const heading = document.createElement("h1");
heading.textContent = "Tracking Details"; // Default title
  historyContainer.appendChild(heading);

  const title = document.createElement("div");
  title.className = "detail-tile"
  title.textContent = "Last Activity"; // Default title
  historyContainer.appendChild(title);

  const list = document.createElement("ul");
  list.className = "history-list";

  // Show only first 2 items initially
  const isExpandable = history.length > 3;
  const initialItems = isExpandable ? history.slice(-3) : history;

  initialItems.reverse().forEach((item) => {
    const text = item.Status || item.status || item.transactionStatusMessage;
    const time = new Date(item.Activity_datetime || item.updatedAt || `${item.Activity_Date} ${item.Activity_Time}`)
      .toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });

    const li = document.createElement("li");
    li.className = "history-item";
    li.innerHTML = `<div class="history-time">${time}</div><div class="history-status">${text}</div>`;
    list.appendChild(li);
  });

  historyContainer.appendChild(list);

  // Add show/hide button if more than 3 history entries
  if (isExpandable) {
    const toggleButton = document.createElement("div");
    toggleButton.textContent = "Show More";
    toggleButton.className = "show-more-btn";

    toggleButton.addEventListener("click", () => {
      const showingAll = toggleButton.textContent === "Show Less";
      list.innerHTML = ""; // Clear list

      const itemsToRender = showingAll ? history.slice(-3).reverse() : history.slice().reverse();
      itemsToRender.forEach((item) => {
        const text = item.Status || item.status || item.transactionStatusMessage;
        const time = new Date(item.Activity_datetime || item.updatedAt || `${item.Activity_Date} ${item.Activity_Time}`)
          .toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });

        const li = document.createElement("li");
        li.className = "history-item";
        li.innerHTML = `<h2 class="history-status">${text}</h2><div class="history-time">${time}</div>`;
        list.appendChild(li);
      });

      // Update button text
      toggleButton.textContent = showingAll ? "Show More" : "Show Less";

      // Update title
      title.textContent = showingAll ? "Last Activity" : "All Activities";
    });

    historyContainer.appendChild(toggleButton);
  }

// === Create carrier content container ===
const carrier = document.createElement("div");
carrier.className = "carrier-content";

// === Create logo image element ===
const carrierLogo = document.createElement("img");
carrierLogo.className = "carrier-logo";
carrierLogo.alt = "Carrier Logo";

const trackingLink = document.createElement("a");
trackingLink.className = "tracking-number";
trackingLink.textContent = trackingNumber;
trackingLink.href = "#"; // Will be set based on carrier
trackingLink.target = "_blank"; // Open in new tab

// === Determine carrier type and set values ===
if (trackingNumber.startsWith("LE")) {
  carrierLogo.src = "https://cdn.shopify.com/s/files/1/0703/3641/3921/files/Leopards_logo.png?v=1752419852";
  trackingLink.href = `https://www.leopardscourier.com/shipment_tracking?cn_number=${trackingNumber.trim()}`;
} else {
  carrierLogo.src = "https://cdn.shopify.com/s/files/1/0703/3641/3921/files/images_1.png?v=1752419361";
  trackingLink.href = `https://postex.pk/tracking?tracking_number=${trackingNumber.trim()}`;
}
// === Append logo and text container to carrier ===
carrier.appendChild(carrierLogo);
// === Append name and tracking number to text container ===
carrier.appendChild(trackingLink);


// === Finally, append carrier section to the result container ===
resultDiv.appendChild(carrier);



historyContainer.appendChild(carrier)



  resultDiv.appendChild(historyContainer);
}


  // === Get Order Info + Product Images from Shopify ===
  async function fetchShopifyOrderDetails(orderNumber) {
    try {
      const cleanOrderNumber = orderNumber.replace("#", "");
      const response = await fetch(`${API_BASE}/shopify/order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ orderNumber: cleanOrderNumber })
      });

      const { orders } = await response.json();
      const order = orders?.[0];
      if (!order) throw new Error("Order not found");

      const products = await Promise.all(order.line_items.map(async item => {
        let image = `https://cdn.shopify.com/s/files/1/0703/3641/3921/products/placeholder.jpg`;
        if (item.product_id) {
          const imgRes = await fetch(`${API_BASE}/shopify/product-image`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ productId: item.product_id })
          });
          const imgData = await imgRes.json();
          if (imgRes.ok) image = imgData.image;
        }
        return { title: item.title, price: item.price, quantity: item.quantity, image };
      }));

      renderProductDetails(products);
    } catch (err) {
      console.error("Shopify Order Error:", err);
    }
  }

  // === Render Ordered Product Info ===
  function renderProductDetails(products) {
    const section = document.createElement("div");
    section.className = "product-summary-custom";

    const title = document.createElement("h1");
    title.textContent = "Review Your Order";
    section.appendChild(title);

    products.forEach(product => {
      const item = document.createElement("div");
      item.className = "product-item-custom";
      item.innerHTML = `
      
        <img src="${product.image}" alt="${product.title}" class="product-image-custom">
      
        <div class="product-info-custom">
          <div class="product-title-custom">${product.quantity} × ${product.title}</div>
          <div class="product-price-custom">PKR ${product.price}</div>
        </div>`;
      section.appendChild(item);
    });

    resultDiv.appendChild(section);
  }

  // === Format Date String ===
  function formatDate(dateInput) {
    const d = new Date(dateInput);
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  }
});